import { mdiCog } from '@mdi/js';
import * as React from 'react';
import * as S from './settings-button.styles';

export interface ISettingsButtonProps {
    to?: string;
}

export class SettingsButton extends React.PureComponent<ISettingsButtonProps> {
    public render(): React.ReactElement {
        const to = this.props.to || '/settings';
        return (
            <S.NavLink to={to}>
                {(props): React.ReactElement => (
                    <S.StyledButton variant="fab-light">
                        <S.StyledIcon path={mdiCog} />
                    </S.StyledButton>
                )}
            </S.NavLink>
        );
    }
}
